import React from 'react';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import getTaxonomy from '../../lib/page-taxonomy';

import COLResults from './col-results';
import type { COLResultsProps } from './col-results';

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () => `${appConfigs.SITE_BASE_URL}/cost-of-living-calculator`,
  metadataOptions: () => {
    return {
      nerdLayoutMappings: { pageTaxonomy: getTaxonomy('col') },
    };
  },
};

const COLResultsWrapper = (props: COLResultsProps): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={COLResults}
    />
  );
};

export default COLResultsWrapper;
